import { render, staticRenderFns } from "./AudioElement.vue?vue&type=template&id=f2999432"
import script from "./AudioElement.vue?vue&type=script&lang=js"
export * from "./AudioElement.vue?vue&type=script&lang=js"
import style0 from "./AudioElement.vue?vue&type=style&index=0&id=f2999432&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports